module.exports = __webpack_public_path__ + "static/media/chart-pdf-arrow.276ec6a5.jpg";